import { render, staticRenderFns } from "./RateScale.vue?vue&type=template&id=31c13784&scoped=true"
import script from "./RateScale.vue?vue&type=script&lang=js"
export * from "./RateScale.vue?vue&type=script&lang=js"
import style0 from "./RateScale.vue?vue&type=style&index=0&id=31c13784&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c13784",
  null
  
)

export default component.exports